module.exports = __webpack_public_path__ + "static/media/type.3c3af3c8.jpeg";